import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

export function CollapsibleSection(props) {
  const { title, sx, children, ...passThroughProps } = props;
  return (
    <Accordion
      sx={{
        borderRadius: '8px !important',
        border: '1px solid #e0e0e0',
        my: '8px !important',
        boxShadow: 'none',
        '&:before': { display: 'none' },
        ...sx,
      }}
      {...passThroughProps}
    >
      <AccordionSummary
        expandIcon={<ArrowDropDownIcon />}
        sx={{
          '&.Mui-expanded': { minHeight: 48 },
          '& .MuiAccordionSummary-content.Mui-expanded': { my: 0 },
        }}
      >
        <Typography component="span" sx={{ fontWeight: 500 }}>
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ px: 2, mb: -1 }}>{children}</AccordionDetails>
    </Accordion>
  );
}
